import { PageIntro } from "../components/PageIntro";
import { Reveal } from "../components/Motion";
import { MapPin, TrendingUp } from "lucide-react";
import { PROJECTS, FURTHER_OPPORTUNITIES } from "../data";

const STAGE_COLORS = {
  "JORC Resource": "bg-mm-blue text-white",
  "Inferred Resource": "bg-mm-blue text-white",
  "Development-Ready": "bg-brand-green text-white",
  "Exploration Licence": "bg-mm-accent text-white",
  "Advanced Exploration": "bg-mm-accent text-white",
};

export default function Projects() {
  return (
    <div data-testid="projects-page">
      <PageIntro
        label="Critical Minerals Portfolio"
        title="A global pipeline of critical-mineral opportunities."
        subtitle="Lithium, copper, nickel, uranium and rare earths across four continents — each evaluated through AI-driven geological intelligence and rigorous due diligence."
      />

      <section className="max-w-[1400px] mx-auto px-6 md:px-10 py-24 md:py-28">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {PROJECTS.map((p, i) => (
            <Reveal key={p.id} delay={(i % 3) * 0.08}>
              <div data-testid={`project-card-${p.id}`} className="group h-full flex flex-col bg-white border border-mm-line rounded-lg overflow-hidden shadow-card hover:shadow-cardHover transition-all duration-300">
                <div className="relative aspect-[16/10] overflow-hidden">
                  <img src={p.image} alt={p.name} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" />
                  <span className={`absolute top-4 left-4 px-3 py-1 rounded font-mono text-[0.6rem] tracking-widest uppercase ${STAGE_COLORS[p.stage] || "bg-white text-mm-blue"}`}>
                    {p.stage}
                  </span>
                </div>
                <div className="p-6 flex-1 flex flex-col">
                  <p className="font-mono text-xs tracking-[0.14em] uppercase text-mm-accent">{p.mineral}</p>
                  <h3 className="font-display font-bold text-2xl text-mm-ink mt-2">{p.name}</h3>
                  <p className="flex items-center gap-1.5 text-sm text-mm-muted mt-1"><MapPin size={14} /> {p.location} · {p.region}</p>
                  <p className="text-mm-muted leading-relaxed mt-4 flex-1">{p.blurb}</p>
                  <div className="mt-5 pt-4 border-t border-mm-line flex items-center gap-2 text-mm-blue font-semibold">
                    <TrendingUp size={16} className="text-mm-accent" /> {p.stat}
                  </div>
                </div>
              </div>
            </Reveal>
          ))}
        </div>

        {/* Further opportunities */}
        <Reveal delay={0.1} className="mt-14">
          <div className="bg-mm-light border border-mm-line rounded-lg p-8 md:p-10">
            <p className="overline mb-5">Further opportunities under review</p>
            <div className="flex flex-wrap gap-3">
              {FURTHER_OPPORTUNITIES.map((o) => (
                <span key={o} className="bg-white border border-mm-line rounded-md px-4 py-2 text-mm-ink font-medium">{o}</span>
              ))}
            </div>
          </div>
        </Reveal>

        <p className="mt-8 text-sm text-mm-muted max-w-3xl">
          Resource figures are as reported by project owners and third parties. All opportunities are subject to detailed technical, commercial, legal and financial due diligence.
        </p>
      </section>
    </div>
  );
}
